var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg69(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "34px",
    viewBox: "0 0 24 34",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01634 12.7118C0.638167 12.7118 0.259994 12.5231 0.0709075 12.1458C-0.118179 11.5798 0.0709075 11.0137 0.638167 10.8251L29.7575 0.0707521C30.3248 -0.11792 30.892 0.0707521 30.892 0.636769C31.0811 1.20279 30.892 1.7688 30.3248 1.95747L1.20543 12.5231C1.20543 12.7118 1.01634 12.7118 1.01634 12.7118Z",
    transform: "matrix(0.37460664 0.92718387 -0.92718387 0.37460664 11.786133 0)",
    id: "Path",
    fill: "#575757",
    fillOpacity: 0.8662807,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg69);
export default __webpack_public_path__ + "static/media/69.feb19ad28d3df4b645ed9f3b1ae1ff10.svg";
export { ForwardRef as ReactComponent };